/** A search window as `yyyy-MM-dd` strings. */
export interface DateWindow {
  startDate: string;
  endDate: string;
}

/**
 * Move the window's start, keeping it valid: a start past the current end drags
 * the end along with it, so the form never sends `fromDate > toDate` (which the
 * engine answers with an empty window rather than an error). `yyyy-MM-dd`
 * strings order the same as the dates they name.
 */
export function withStartDate(window: DateWindow, nextStart: string): DateWindow {
  const endDate = window.endDate && nextStart > window.endDate ? nextStart : window.endDate;
  return { startDate: nextStart, endDate };
}
